import { cn } from '@/lib/utils';

interface SpacerSectionProps {
  content: {
    height?: 'small' | 'medium' | 'large' | 'xlarge';
  };
  variant?: string;
  layoutStyle?: string;
}

export function SpacerSection({ content }: SpacerSectionProps) {
  const { height = 'medium' } = content;

  return (
    <div className={cn(
      height === 'small' && 'h-8 md:h-12',
      height === 'medium' && 'h-16 md:h-24',
      height === 'large' && 'h-24 md:h-32',
      height === 'xlarge' && 'h-32 md:h-48'
    )} />
  );
}